var map = {
	"./chat.png": 5695,
	"./hands-with-pen.png": 8981,
	"./info.png": 5451,
	"./logo-zetta.png": 341,
	"./qsoft-logo.png": 3619,
	"./suitcase.png": 2999,
	"./wallet.png": 2106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;